import { render, staticRenderFns } from "./MAbout.vue?vue&type=template&id=0fe94af2&scoped=true&"
import script from "./MAbout.vue?vue&type=script&lang=js&"
export * from "./MAbout.vue?vue&type=script&lang=js&"
import style0 from "./MAbout.vue?vue&type=style&index=0&id=0fe94af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe94af2",
  null
  
)

export default component.exports